import { gql } from '@apollo/client';

export const FETCH_STAFF_PAYMENT = gql`
  query getStaffsPayment {
    getStaffPayment {
      _id
      name
      category
      payStatus
      paymentConfig {
        nsmInvigilationRate
        smInvigilationRate
        snackRate
        tax
      }
      hours
      snackAmt
      invigilationAmt
      total
      amountDue
      bankBranch
      bankAccNumber
      bankName
    }
  }
`;
